export const ANALYTICS_CONSENT_COOKIE = "peakwave_analytics_consent";
export const ANALYTICS_CONSENT_CHANGED_EVENT =
  "peakwave:analytics-consent-changed";
export const ANALYTICS_CONSENT_SETTINGS_EVENT =
  "peakwave:analytics-consent-settings";

export type AnalyticsConsent = "accepted" | "rejected";

const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 180;

export function parseAnalyticsConsent(
  cookieHeader: string,
): AnalyticsConsent | null {
  const prefix = `${ANALYTICS_CONSENT_COOKIE}=`;
  const value = cookieHeader
    .split(";")
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(prefix))
    ?.slice(prefix.length);

  return value === "accepted" || value === "rejected" ? value : null;
}

export function readAnalyticsConsent(): AnalyticsConsent | null {
  if (typeof document === "undefined") return null;
  return parseAnalyticsConsent(document.cookie);
}

export function serialiseAnalyticsConsentCookie(
  consent: AnalyticsConsent,
  secure: boolean,
): string {
  return [
    `${ANALYTICS_CONSENT_COOKIE}=${consent}`,
    "Path=/",
    `Max-Age=${CONSENT_MAX_AGE_SECONDS}`,
    "SameSite=Lax",
    secure ? "Secure" : null,
  ]
    .filter(Boolean)
    .join("; ");
}

export function writeAnalyticsConsent(consent: AnalyticsConsent): void {
  if (typeof document === "undefined") return;
  document.cookie = serialiseAnalyticsConsentCookie(
    consent,
    window.location.protocol === "https:",
  );
  window.dispatchEvent(new CustomEvent(ANALYTICS_CONSENT_CHANGED_EVENT));
}
